/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUser } from 'app/shared/model/user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';

export interface IHospitalManager {
  id?: string;
  active?: boolean;
  name?: string;
  email?: string;
  mobile?: string;
  dateOfBirth?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  cursor?: number;
  education?: string | null;
  experience?: string | null;
  gender?: keyof typeof Gender;
  bloodGroup?: keyof typeof BloodGroup;
  tmUser?: IUser;
  contactCode?: IContactDetails;
  hospital?: IHospital;
}

export const defaultValue: Readonly<IHospitalManager> = {
  active: false,
};
